import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface ByRepairIdsMercuryTransactionAllocationsQueryOptions {
  repairIds: Ref<string[]>;
}

export const byRepairIdsMercuryTransactionAllocationsQuery = (
  options: ByRepairIdsMercuryTransactionAllocationsQueryOptions,
) => {
  return queryOptions({
    queryKey: [
      "mercury-transaction-allocations",
      "by-repair-ids",
      options.repairIds,
    ],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["byRepairIdsMercuryTransactionAllocations"][200]
    > =>
      handleClientMethod(
        getClient().GET("/mercury-transaction-allocations/by-repair-ids", {
          params: {
            query: {
              repairIds: options.repairIds.value,
            },
          },
        }),
      ),
  });
};
